import {Action} from "redux";
import {MessageId, OpenedStatus, SentStatus} from "./data";

export type CommunicationsMessageFiltersAction = SetMessagesAction
	| SetSentStatusAction
	| SetOpenedStatusAction

type SetMessagesAction = {
	type: "set messages",
	messages: MessageId[]
}

type SetSentStatusAction = {
	type: "set sent status",
	sentStatus: SentStatus
}

type SetOpenedStatusAction = {
	type: "set opened status",
	openedStatus: OpenedStatus
}

export type CommunicationsMessageFiltersActionWrapper = {
	type: 'communications message filters action'
	action: CommunicationsMessageFiltersAction
}

export const isCommunicationsMessageFiltersAction = (a: Action): a is CommunicationsMessageFiltersActionWrapper => {
	return a.type == "communications message filters action"
}



// WEBPACK FOOTER //
// ./src/contacts/querybuilder-filters/communications-message/actions.ts